import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import btoa from 'btoa';

import { accountLogout } from '../../../ducks/user/auth';
import { isMobile, openLogin } from '../../../mobile/helpers';
import { navigate } from '../../../helpers';
import Content from '../components/Content';
import Empty from '../components/Empty';
import Header from '../components/Header';
import Profile from './Profile';
import styles from './Profile/profile.scss';
import withUser from '../../../components/withUser';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
  }),
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string,
  }),
};

export const gotoLogin = (history) => {
  if (isMobile()) {
    openLogin();
  } else {
    const returnUrl = `${history.location.pathname}${history.location.search}`;
    navigate(history, `/login/${btoa(returnUrl)}`);
  }
};

const Me = ({
  user,
  history,
  dispatch,
  location,
  match,
}) => (
  <>
    { user
      ? (
        <Profile
          history={history}
          location={location}
          match={match}
          onLogout={
          isMobile() && window
            ? window.logout
            : () => dispatch(accountLogout())
        }
        />
      )
      : (
        <>
          <Header
            right={(
              <div
                className={styles.done}
                role="button"
                tabIndex={0}
                onClick={() => history.stackPop()}
              >
                Done
              </div>
            )}
          >
            Login
          </Header>
          <Content>
            <Empty
              empty={!user}
              title="Log in"
              message="Log in to see your profile. Don't have an account? Creating one only takes a minute."
              button={{
                onClick: () => gotoLogin(history),
                text: 'Log in or register now',
              }}
            />
          </Content>
        </>
      )}
  </>
);

Me.propTypes = propTypes;

export default connect()(withUser(Me));
